<template>
  <div class="card p-4 shadow-sm">
    <!-- Botón de regreso -->
    <button
      class="btn btn-outline-secondary btn-sm mb-3"
      @click="$router.push('/inicio')"
      type="button"
    >
      <i class="bi bi-arrow-left me-1"></i> Regresar
    </button>

    <!-- Tabs de reportes -->
    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <button
          class="nav-link"
          :class="{ active: tabActivo === 'ocupadas' }"
          @click="tabActivo = 'ocupadas'"
        >
          <i class="bi bi-house-door me-1"></i> Habitaciones Ocupadas
        </button>
      </li>
      <li class="nav-item">
        <button
          class="nav-link"
          :class="{ active: tabActivo === 'reservasDia' }"
          @click="tabActivo = 'reservasDia'"
        >
          <i class="bi bi-calendar3 me-1"></i> Reservas por Día
        </button>
      </li>
    </ul>

    <!-- ───────── TAB: Habitaciones Ocupadas ───────── -->
    <div v-if="tabActivo === 'ocupadas'">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="m-0">Habitaciones ocupadas</h4>
        <button
          type="button"
          class="btn btn-danger"
          @click="descargarPDF"
          :disabled="!reporte || cargando"
          title="Descargar reporte en PDF"
        >
          <i class="bi bi-file-pdf me-1"></i> Descargar PDF
        </button>
      </div>

      <!-- Loading -->
      <div v-if="cargando" class="text-center py-5">
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        ></div>
        <span class="ms-2 text-muted">Cargando...</span>
      </div>

      <!-- Resultado -->
      <div v-if="reporte && !cargando" class="resultado-card">
        <div class="text-muted small mb-2">
          {{ formatearFecha(reporte.fecha) }}
        </div>
        <div class="mb-3">
          <strong>Total habitaciones ocupadas: </strong
          >{{
            (reporte.habitaciones_ocupadas &&
              reporte.habitaciones_ocupadas.length) ||
            0
          }}
        </div>
        <table class="table table-bordered table-sm text-center">
          <thead>
            <tr>
              <th>Número de Habitación</th>
              <th>Personas</th>
              <th>Niños</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="h in reporte.habitaciones_ocupadas"
              :key="h.NumeroHabitacion"
            >
              <td>{{ h.NumeroHabitacion }}</td>
              <td>{{ h.CantidadPersonasAlojadas }}</td>
              <td>{{ h.CantidadNinios }}</td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="
            !reporte.habitaciones_ocupadas ||
            reporte.habitaciones_ocupadas.length === 0
          "
          class="text-muted text-center py-3"
        >
          No hay habitaciones ocupadas en esta fecha.
        </div>
      </div>
    </div>

    <!-- ───────── TAB: Reservas por Día ───────── -->
    <div v-if="tabActivo === 'reservasDia'">
      <h4 class="mb-3">Reservas por Día (fecha de creación)</h4>

      <div class="row g-2 align-items-end mb-4">
        <div class="col-auto">
          <label class="form-label"><strong>Fecha:</strong></label>
          <input type="date" v-model="fechaReservasDia" class="form-control" />
        </div>
        <div class="col-auto">
          <label class="form-label"><strong>Hora inicio:</strong></label>
          <input type="time" v-model="horaInicioReservasDia" class="form-control" style="max-width: 125px" />
        </div>
        <div class="col-auto">
          <label class="form-label"><strong>Hora fin:</strong></label>
          <input type="time" v-model="horaFinReservasDia" class="form-control" style="max-width: 125px" />
        </div>
        <div class="col-auto">
          <button
            class="btn btn-primary"
            @click="obtenerReservasPorDia"
            :disabled="cargandoReservasDia"
          >
            <span
              v-if="cargandoReservasDia"
              class="spinner-border spinner-border-sm me-1"
            ></span>
            <i v-else class="bi bi-search me-1"></i> Consultar
          </button>
        </div>
      </div>

      <!-- Loading -->
      <div v-if="cargandoReservasDia" class="text-center py-4">
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        ></div>
        <span class="ms-2 text-muted">Cargando...</span>
      </div>

      <!-- Resultado -->
      <div v-if="reporteReservasDia && !cargandoReservasDia">
        <p class="text-muted small mb-2">
          Reservas creadas el {{ formatearFecha(reporteReservasDia.fecha) }} —
          <strong>{{ reporteReservasDia.total_reservas }}</strong> reserva(s)
        </p>

        <div
          v-if="reporteReservasDia.reservas.length > 0"
          class="table-responsive"
        >
          <table class="table table-bordered table-sm align-middle">
            <thead class="table-light">
              <tr>
                <th>#</th>
                <th>Habitación</th>
                <th>Personas</th>
                <th>Niños</th>
                <th>Huésped</th>
                <th class="text-end">Total Hospedaje</th>
                <th class="text-end">Total Restaurante</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(fila, idx) in reporteReservasDia.reservas" :key="idx">
                <td class="text-muted small">
                  R{{ String(fila.IdReserva).padStart(4, "0") }}
                </td>
                <td>{{ fila.NumeroHabitacion }}</td>
                <td class="text-center">{{ fila.CantidadPersonas }}</td>
                <td class="text-center">{{ fila.CantidadNinos }}</td>
                <td>{{ fila.NombreHuesped }}</td>
                <td class="text-end">
                  Q{{ Number(fila.TotalHospedaje).toFixed(2) }}
                </td>
                <td class="text-end">
                  Q{{ Number(fila.TotalRestaurante).toFixed(2) }}
                </td>
              </tr>
            </tbody>
            <tfoot class="table-secondary fw-bold">
              <tr>
                <td colspan="5" class="text-end">TOTALES</td>
                <td class="text-end">
                  Q{{ Number(reporteReservasDia.total_hospedaje).toFixed(2) }}
                </td>
                <td class="text-end">
                  Q{{ Number(reporteReservasDia.total_restaurante).toFixed(2) }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div v-else class="text-center text-muted py-3">
          No se encontraron reservas creadas en esta fecha.
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div class="toast show align-items-center text-white bg-danger">
        <div class="d-flex">
          <div class="toast-body">
            <i class="bi bi-exclamation-circle me-2"></i> {{ alerta.mensaje }}
          </div>
          <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            @click="cerrarToast"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "ReportesHotel",
  data() {
    return {
      tabActivo: "ocupadas",
      reporte: null,
      cargando: false,
      // Reservas por día
      fechaReservasDia: new Date().toLocaleDateString("fr-CA"),
      horaInicioReservasDia: '00:00',
      horaFinReservasDia: '23:59',
      reporteReservasDia: null,
      cargandoReservasDia: false,
      mostrarToast: false,
      alerta: { mensaje: "" },
    };
  },
  methods: {
    async obtenerReporte() {
      this.cargando = true;
      this.reporte = null;
      try {
        const res = await axios.get(`${API_URL}/habitaciones-ocupadas`);
        this.reporte = res.data;
      } catch (error) {
        console.error("Error obteniendo reporte:", error);
        this.mostrarAlerta("Error al obtener el reporte");
      } finally {
        this.cargando = false;
      }
    },
    async obtenerReservasPorDia() {
      if (!this.fechaReservasDia) {
        this.mostrarAlerta("Selecciona una fecha");
        return;
      }
      this.cargandoReservasDia = true;
      this.reporteReservasDia = null;
      try {
        const res = await axios.get(`${API_URL}/reservas-por-dia`, {
          params: {
            fecha: this.fechaReservasDia,
            hora_inicio: this.horaInicioReservasDia,
            hora_fin: this.horaFinReservasDia,
          },
        });
        this.reporteReservasDia = res.data;
      } catch (error) {
        console.error("Error obteniendo reporte reservas por día:", error);
        this.mostrarAlerta("Error al obtener el reporte");
      } finally {
        this.cargandoReservasDia = false;
      }
    },
    formatearFecha(fecha) {
      if (!fecha) return "";
      const [year, month, day] = fecha.split("-");
      return `${day}/${month}/${year}`;
    },
    mostrarAlerta(mensaje) {
      this.alerta = { mensaje };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
    async descargarPDF() {
      if (!this.reporte) {
        this.mostrarAlerta("No hay datos para generar el PDF");
        return;
      }

      try {
        const response = await axios.get(
          `${API_URL}/habitaciones-ocupadas-pdf`,
          {
            params: { fecha: this.reporte.fecha },
            responseType: "blob",
          },
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Habitaciones_Ocupadas_${this.reporte.fecha}.pdf`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Error descargando PDF:", error);
        this.mostrarAlerta("Error al generar el PDF");
      }
    },
  },
  mounted() {
    this.obtenerReporte();
    this.obtenerReservasPorDia();
  },
};
</script>

<style scoped>
.resultado-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
}
</style>
